import {useEffect, useState} from 'react'
import {getAccessesNews} from '../api/modules/access/access'
import {useAppSelector} from 'src/redux/hooks'
import {authSelector} from 'src/redux/slices/authSlices'

interface IAccess {
  approve: boolean
  attachment: boolean
  create: boolean
  delete: boolean
  export: boolean
  icon: null
  id: number
  name: string // 'News Management'
  parent_id: number
  print: boolean
  read: boolean
  update: boolean
}

export const useFetchAccessMenu = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<any>('')
  const [accesses, setAccesses] = useState<IAccess | null>(null)
  const {roleId} = useAppSelector(authSelector)

  const getAccessMenu = async () => {
    try {
      setIsLoading(true)
      const res = await getAccessesNews(roleId)
      setAccesses(res.data.data as IAccess)
    } catch (error) {
      setError(error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    getAccessMenu()
  }, [])

  return {
    isLoading,
    error,
    accesses,
  }
}
